import React from 'react'
import ListGroupNav from '../../components/navbar/internal/ListGroupNav'
import { Outlet, useParams } from 'react-router-dom'
import { TenantRouteParam } from '../context/tenant.context'

const DashboardHome = () => {
  const { tenantID } = useParams<TenantRouteParam>()
  return (
    <>
      <div className={'mb-2'}>
        <ListGroupNav />
      </div>
      <Outlet
        context={{
          tenantIDParam: tenantID,
        }}
      />
    </>
  )
}

export default DashboardHome
